import React from 'react';
import { compileLess } from '../helpers/lessCompiler';

/**
 * EditorApplyStyles is a React component that takes in styles (either CSS or Less) as props,
 * compiles them if necessary, and applies them to the document using a <style> tag.
 * It listens for changes in the styles and re-compiles if the styles or the isLess flag changes.
 */
export default class EditorApplyStyles extends React.PureComponent {

  // Initialize state with compiledCss, isLess, isCompiling, and error
  constructor(props) {
    super(props);
    this.state = {
      compiledCss: props.styles || '',
      isLess: props.isLess || false,
      isCompiling: false,
      error: null
    };
  }

  // When the component mounts, compile the styles if needed
  componentDidMount() {
    this.compileIfNeeded();
  }

  // When the component updates, check if styles or isLess has changed and re-compile if necessary
  componentDidUpdate(prevProps) {
    if (
      prevProps.styles !== this.props.styles ||
      prevProps.update !== this.props.update ||
      prevProps.isLess !== this.props.isLess
    ) {
      this.compileIfNeeded();
    }
  }

  // Method to compile Less styles if needed, or directly set CSS if not Less
  compileIfNeeded() {
    const { styles, isLess = false } = this.props || {};
    if (!styles) {
      this.setState({ compiledCss: '', isLess: false });
      return;
    }

    if (isLess) {
      this.setState({ isCompiling: true, error: null });
      compileLess(styles)
        .then(compiledCss => {
          this.setState({ compiledCss, isCompiling: false });
        })
        .catch(error => {
          console.error('Error compiling Less:', error);
          this.setState({ error: 'Failed to compile Less', isCompiling: false, compiledCss: styles });
        });
    } else {
      this.setState({ compiledCss: styles, isLess: false });
    }
  }

  // Render the compiled CSS inside a <style> tag
  render() {
    const { compiledCss, isLess } = this.state;
    return <style jsx="true">{`${compiledCss}`}</style>
  }
}
